module.exports = __webpack_public_path__ + "img/Logo Fantini rosso.dcd7f775.png";